import { useState, useEffect, useRef } from "react";
import AgilityRichText from "./AgilityRichText";
import FAQ from "./FAQ";
import MemoCloseIcon from "src/components/common/Icons/CloseIcon";

const LogoListing = ({ title, description, items }) => {
  const modalContentRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [activeModalContent, setActiveModalContent] = useState(null);

  useEffect(() => {
    let copyElements = null;

    function handleClick(e) {
      const targetId = e.currentTarget.getAttribute("data-copy");
      if (targetId) {
        e.preventDefault();
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          const textToCopy = targetElement.textContent;
          navigator.clipboard.writeText(textToCopy)
            .then(() => alert("Text copied to clipboard"))
            .catch(err => console.error("Failed to copy:", err));
        }
      }
    }

    if(!!showModal){
      setTimeout(() => {
        copyElements = document.querySelectorAll("[data-copy]");
        copyElements?.forEach((element) => {
          element.addEventListener("click", handleClick);
        });
      }, 500)
    }
  
    // cleanup
    return () => {
      copyElements?.forEach((element) => {
        element.removeEventListener("click", handleClick);
      });
    };
  }, [showModal]);

  useEffect(() => {
    // detect outside click modal
    const handleOutsideClick = (event) => {
      if (modalContentRef.current && !modalContentRef.current.contains(event.target)) {
        setShowModal(false);
        setActiveModalContent(null);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);

    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [showModal])
  

  useEffect(() => {
    // change html overflow
    document.documentElement.style.overflow = showModal ? "hidden" : "auto";
  }, [showModal])

  return (
    <section className="logo-listing tw-my-8">
      <div className="tw-container">
        {title && (
          <h2 className="tw-font-helv tw-text-3.5xl tw-normal-case tw-font-bold tw-mb-4">{title}</h2>
        )}
        {description && (
          <AgilityRichText
            html={description}
            className="[&>*]:tw-font-helv"
          />
        )}
        <div className="tw-grid tw-grid-cols-2 tw-gap-4 md:tw-grid-cols-3 lg:tw-grid-cols-5">
          {items?.map(({fields}, index) => (
            <div 
              key={index} 
              className="tw-shadow-md tw-border tw-border-black/20 hover:tw-cursor-pointer" 
              onClick={() => {
                setShowModal(true);
                setActiveModalContent(fields);
              }}
            >
              {fields?.icon &&
                <img
                  src={fields.icon.url}
                  alt={fields.icon.label}
                  className="tw-w-full tw-h-auto"
                />
              }
              <div className="tw-pt-2 tw-p-3">
                {fields?.title &&
                  <h3 className="tw-font-helv tw-text-sm tw-normal-case tw-font-bold">{fields.title}</h3>
                }
                {fields?.description &&
                  <AgilityRichText
                    html={fields.description}
                    className="[&>*]:tw-font-helv tw-mt-4"
                  />
                }
              </div>
            </div>
          ))}
        </div>

        {/* Modal */}
        {!!showModal && !!activeModalContent &&
          <div className="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-black/30 tw-flex tw-justify-center tw-items-center tw-z-50">
            <div ref={modalContentRef} className="tw-bg-white tw-max-w-100 tw-my-8 tw-max-h-[calc(100vh-64px)] tw-overflow-auto">
              <div className="tw-p-6">
                {/* Close icon */}
                <div className="tw-flex tw-justify-end">
                  <button onClick={() => setShowModal(false)}>
                    <MemoCloseIcon className="tw-text-lg"/>
                  </button>
                </div>
                {activeModalContent?.content &&
                  <AgilityRichText
                    html={activeModalContent.content}
                    className="[&>*]:tw-font-helv tw-mt-4"
                  />
                }
                {activeModalContent?.accordions &&
                  <FAQ faqs={activeModalContent.accordions} type="white" className="!tw-p-0 tw-my-6"/>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </section>
  );
};

export default LogoListing;



